/**
 * 大区组件通用mixins
 */

import { mapGetters, mapActions } from "vuex"
import * as enums from "../../store/enums"
import * as cgiApi from "@api/cgi"
import { MobileZone, PcZone } from "@tencent/midas-widgets-domestic"
import localStorage from "@utils/localStorage"
import * as url from "@utils/url"
import * as userApi from "@api/user"
import { session_skey, session_qqconnect, session_pskey } from "@tencent/midas-util"
import { checkIfUserAgreed, getAuthManageItemKey } from "../../business/auth"
import * as helper from "@utils/helper"
import { loginStateUtil } from "@utils/loginState"
// 通用大区组件
let mobileZoneSelector
let pcZoneSelector

export default {
  data() {
    return {
      userZoneInfo: {}
    }
  },

  computed: {
    ...mapGetters([
      "userAgent",
      "loginState",
      "currentItem",
      "provideAccountType",
      "sessionObj",
      "zoneRoleInfoCache",
      "parseCachedZoneRolePromise",
      "fromMini",
      "serviceZoneStatus"
    ]),

    // 是否是端游
    isPcGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
    },
    // 是否是手游
    isMobileGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.MOBILE_GAME
    },
    gameCoinOfferId() {
      return this.currentItem[this.userAgent.iOS ? "ios" : "android"][this.provideAccountType.toLowerCase()]?.offerid
    },
    roleNoCheck() {
      if (this.currentItem.categoryId == enums.BUSINESS_TYPE.MOBILE_GAME) {
        return this.currentItem.roleType == enums.CHECK_ROLE_TYPE.NO_CHECK
      } else if (this.currentItem.categoryId == enums.BUSINESS_TYPE.PC_GAME) {
        return this.currentItem?.game_info?.check_type == enums.CHECK_ROLE_TYPE.NO_CHECK
      }
    },
    checkSessionType() {
      return userApi.checkSessionType({ sessionObj: this.sessionObj })
    },
    outerIsThirdSession() {
      return url.getParam("sessiontype") == "st_local_third_party" || url.getParam("sessiontype") == "st_third_party"
    },
    forceUseZoneJs() {
      return url.getParam("zoneJs") && url.getParam("zoneKey")
    },
    isWzydIosRole() {
      if (url.getParam("roleid") && (url.getParam("zoneid") || url.getParam("partition"))) {
        return this.userAgent.wzyd && this.userAgent.android && !helper.getWzydZonePlat("areaId").android
      }
      return false
    }
  },

  methods: {
    ...mapActions(["setZoneRoleInfoCache", "setParseCachedZoneRolePromise", "showAppLogin"]),

    newZoneAndRoleSelector({ useCmallQuery = false, thirdOfferId = "" } = {}) {
      // 支持传入大区信息（支持partition和zoneid两套体系）
      // 1. zoneJs | zoneKey | partition | roleid， 采用大区js partirion（partirion，area，game_platform_id）体系查询角色
      // 使用这套逻辑的前提是保证zoneid和partition一一对应，因为会把partition赋值给zoneid

      // 2. zoneid | roleid， 采用zoneid体系查询角色

      if (!this.currentItem || !this.currentItem?.name) {
        console.log("请初始化currentItem")
        return
      }

      // 第三方登录态因为绑定逻辑也切成cmallquery
      if (this.checkSessionType == "third") useCmallQuery = true

      let initParam = {
        convert_roleid: this.currentItem?.convert_roleid || 0,
        unLimitAMSOfferId: !this.serviceZoneStatus,
        zone_js: this.forceUseZoneJs ? url.getParam("zoneJs") : this.currentItem?.zone_js || "",
        zone_key: this.forceUseZoneJs ? url.getParam("zoneKey") : this.currentItem?.zone_key || "",
        account: this.checkSessionType == "wechat" ? "wx" : this.checkSessionType == "qq" ? "qq" : "",
        useCmallQuery: useCmallQuery,
        thirdOfferId
      }

      if (!initParam?.zone_js || !initParam?.zone_key) {
        // 如果使用米大师分区，则需要把之前ams分区（partition）的缓存清除，否则会因为有缓存缺少zoneid，而丧失推荐大区的能力
        // 如果使用大区js，ams分区逻辑，不需要把之前的 米大师分区缓存清除，因为没有推荐大区，用户重新选择过即可
        try {
          let cache = localStorage.get(this.getMobileZoneSelectorCachekey(thirdOfferId), true)
          if (cache?.partition && !cache?.zoneid) {
            localStorage.del(this.getMobileZoneSelectorCachekey(thirdOfferId))
          }
        } catch (err) {
          console.log(err)
        }
      }
      this.initZoneAndRoleSelector(initParam)
    },

    /**
     * 初始化PC大区选择组件
     */
    initPCZoneAndRoleSelector(opt = {}) {
      // 初始化大区数据
      this.userZoneInfo = {}
      this.setParseCachedZoneRolePromise(null)
      let thirdPf = this.isMobileGame ? (this.userAgent.iOS ? "iap" : "android") : "html5"

      let cgiOfferId = ""
      if (opt.unLimitAMSOfferId) {
        cgiOfferId =
          this.currentItem && this.currentItem.ams && this.currentItem.ams.offerid ? this.currentItem.ams.offerid : this.gameCoinOfferId
      } else {
        // 专区页强制走道具offerid查角色
        if (this.currentItem.ams && this.currentItem.ams.offerid) {
          cgiOfferId = this.currentItem.ams.offerid
        } else {
          console.log("请配置道具offerId")
        }
      }

      if (cgiOfferId) {
        if (!opt.loginState) {
          console.log("需要传入登录态信息")
          return
        }
        // 端游需要传入登录态
        let sessionObj = null
        if (loginStateUtil(opt.loginState).pskey) {
          sessionObj = new session_pskey({
            uin: opt.loginState.openid,
            pskey: opt.loginState.openkey,
            sessiontype: opt.loginState.sessionType
          })
        } else if (opt.loginState.sessionType == "skey") {
          sessionObj = new session_skey({
            uin: opt.loginState.openid,
            skey: opt.loginState.openkey
          })
        } else {
          sessionObj = new session_qqconnect({
            qq_appid: opt.loginState.qqAppid,
            openid: opt.loginState.openid,
            accessToken: opt.loginState.openkey
          })
        }
        let cgiObj = cgiApi.getCgiObj({
          pf: `${this.pfSource}-${this.pf}-${thirdPf}`,
          sandbox: this.sandbox * 1,
          sessionObj,
          offerId: cgiOfferId
        })
        if (opt.zone_js && opt.zone_key) {
          pcZoneSelector = new PcZone.DialogApi({
            cgiObj,
            account: "qq", // 端游只有QQ角色
            options: {
              zoneJS: {
                zoneJsURL: opt.zone_js,
                zoneJSKey: opt.zone_key,
                checkType: cgiOfferId === "1450029561" ? 3 : this.currentItem.roleType
              }
            }
          })
        } else {
          console.log("请传入对应的大区JS")
        }
      }
    },

    /**
     * 展示PC大区组件
     */
    showPCZoneAndRoleSelector({ offerId, userId, confirmCb }) {
      pcZoneSelector &&
        pcZoneSelector.show({
          theme: "popup",
          onConfirm: res => {
            if (res && res[0]) {
              let zoneRoleInfoCache = {
                selectedZone: {
                  zone_name: (res[1] || res[0])?.t,
                  zone_id: (res[1] || res[0])?.v
                },
                selectedRole: {
                  partition_info: {
                    partition: "",
                    platid: "",
                    area: (res[1] || res[0])?.v
                  },
                  role_id: res[2]?.role_id,
                  role_name: res[2]?.role_name
                }
              }
              this.setZoneRoleInfoCache({
                offerId: offerId,
                userId: userId,
                zoneRoleInfoCache: zoneRoleInfoCache
              })
              this.setParseCachedZoneRolePromise(null)
              confirmCb && confirmCb(zoneRoleInfoCache)
            }
          }
        })
    },

    /**
     * 通过PC大区组件解析缓存或推荐大区
     * offerId, userId 必传项，为了缓存和取缓存
     */
    parsePCCachedZoneRole({ offerId, userId }) {
      if (!offerId || !userId) {
        console.log("必传字段缺失")
        throw new Error("必传字段缺失")
      }
      if (!this.parseCachedZoneRolePromise) {
        let parseCachedZoneRolePromise = new Promise((resolve, reject) => {
          pcZoneSelector &&
            pcZoneSelector
              .parseCachedZoneRole()
              .then(res => {
                if (res && res[0]) {
                  let zoneRoleInfoCache = {
                    selectedZone: {
                      zone_name: (res[1] || res[0])?.t,
                      zone_id: (res[1] || res[0])?.v
                    },
                    selectedRole: {
                      partition_info: {
                        partition: "",
                        platid: "",
                        area: (res[1] || res[0])?.v
                      },
                      role_id: res[2]?.role_id,
                      role_name: res[2]?.role_name
                    }
                  }
                  this.setZoneRoleInfoCache({
                    offerId: offerId,
                    userId: res[1]?.cgiRes?.bind_ori_user_id || userId,
                    zoneRoleInfoCache: zoneRoleInfoCache
                  })
                  resolve(zoneRoleInfoCache)
                } else {
                  this.setParseCachedZoneRolePromise(null)
                  resolve(res)
                }
              })
              .catch(err => {
                this.setParseCachedZoneRolePromise(null)
                reject(err)
              })
        })
        this.setParseCachedZoneRolePromise(parseCachedZoneRolePromise)
      }

      return this.parseCachedZoneRolePromise
    },

    closePcZoneSelector() {
      pcZoneSelector && pcZoneSelector.close()
    },

    /**
     * 初始化大区选择组件
     */
    initZoneAndRoleSelector(opt = {}) {
      // 初始化大区数据
      this.userZoneInfo = {}
      this.setParseCachedZoneRolePromise(null)
      let thirdPf = this.isMobileGame ? (this.userAgent.iOS ? "iap" : "android") : "html5"

      let cgiOfferId = ""
      if (opt.thirdOfferId) {
        cgiOfferId = opt.thirdOfferId
      } else if (opt.unLimitAMSOfferId) {
        cgiOfferId =
          this.currentItem && this.currentItem.ams && this.currentItem.ams.offerid ? this.currentItem.ams.offerid : this.gameCoinOfferId
      } else {
        // 专区页强制走道具offerid查角色
        if (this.currentItem.ams && this.currentItem.ams.offerid) {
          cgiOfferId = this.currentItem.ams.offerid
        } else {
          console.log("请配置道具offerId")
        }
      }

      if (cgiOfferId) {
        mobileZoneSelector = null

        let cgiObj = cgiApi.getCgiObj({
          pf: `${this.pfSource}-${this.pf}-${thirdPf}`,
          sandbox: this.sandbox * 1,
          sessionObj: this.sessionObj,
          offerId: cgiOfferId
        })

        let queryRoleExtendParams = {}
        // 天龙八部手游角色转进制
        if (opt.convert_roleid == "1") {
          queryRoleExtendParams.convert_roleid = 1
        }

        let zoneJSParam = {}
        if (opt.zone_js && opt.zone_key) {
          zoneJSParam.zoneJS = {
            zoneJsURL: opt.zone_js,
            zoneJSKey: opt.zone_key
          }
        }

        // 这里注意：当用户没有同意隐私协议，是不能推荐出大区 （快手第三方登录态场景每次进入都会）
        mobileZoneSelector = new MobileZone.DialogApi({
          cgiObj,
          account: opt.account || "",
          options: {
            cmall_query: opt.useCmallQuery ? true : false,
            queryRoleExtendParams,
            ...zoneJSParam,
            recommModel: {
              android:
                checkIfUserAgreed(this.currentItem.groupId, this.currentItem.busId, getAuthManageItemKey(this.currentItem, this.pf)) &&
                !this.isWzydIosRole &&
                this.currentItem.partitionRecomm &&
                this.currentItem.partitionRecomm["android"]
                  ? this.currentItem.partitionRecomm["android"]
                  : "",
              iOS:
                checkIfUserAgreed(this.currentItem.groupId, this.currentItem.busId, getAuthManageItemKey(this.currentItem, this.pf)) &&
                !this.isWzydIosRole &&
                this.currentItem.partitionRecomm &&
                this.currentItem.partitionRecomm["iOS"]
                  ? this.currentItem.partitionRecomm["iOS"]
                  : ""
            }
          }
        })
      } else {
        console.log("请配置查询角色offerId")
      }
    },

    /**
     * 展示大区组件
     */
    showZoneAndRoleSelector({ offerId, userId, confirmCb }) {
      let cached = {}

      // 用户缓存
      let userCache = this.zoneRoleInfoCache && this.zoneRoleInfoCache[`${offerId}_${userId}`]
      let { selectedZone, selectedRole } = userCache || {}

      if (selectedZone) {
        cached = {
          zoneid: selectedZone.zone_id,
          roleid: selectedRole && selectedRole.role_id
        }
      } else if (url.getParam("roleid") && (url.getParam("zoneid") || url.getParam("partition"))) {
        cached = {
          zoneid: url.getParam("zoneid"),
          roleid: url.getParam("roleid"),
          partition: url.getParam("partition")
        }
      }
      // 如果存在已经存在一个选大区组件了，则不继续弹了
      if (document.querySelector(".mds-mobile-zone-popup-region")) return

      mobileZoneSelector &&
        mobileZoneSelector.show({
          theme: "popup",
          cached: cached,
          onConfirm: res => {
            // console.log(JSON.stringify(res, null, 4))
            if (res && res[0]) {
              let zoneRoleInfoCache = {
                selectedZone: res && res[0],
                selectedRole: res && res[1]
              }
              this.setZoneRoleInfoCache({
                offerId: offerId,
                userId: userId,
                zoneRoleInfoCache: zoneRoleInfoCache
              })
              if (res[1]?.cgiRes?.bind_ori_user_id)
                this.setZoneRoleInfoCache({
                  offerId: offerId,
                  userId: res[1].cgiRes.bind_ori_user_id,
                  zoneRoleInfoCache: zoneRoleInfoCache
                })
              this.setParseCachedZoneRolePromise(null)
              confirmCb && confirmCb(zoneRoleInfoCache)
            }
          },
          onCancel() {}
        })
    },

    /**
     * 通过大区组件解析缓存或推荐大区
     * offerId, userId 必传项，为了缓存和取缓存
     */
    parseCachedZoneRole({ offerId, userId }) {
      if (!offerId) {
        console.error("必传字段缺失")
        throw new Error("必传字段缺失缺失")
      }
      if (!userId) {
        console.error("登录态缺失")
        return Promise.resolve()
      }
      if (!this.parseCachedZoneRolePromise) {
        let parseCachedZoneRolePromise = new Promise((resolve, reject) => {
          // 如果配置台配置的为不选大区角色
          if (this.currentItem.roleType == enums.CHECK_ROLE_TYPE.NO_CHECK) {
            resolve({})
          } else if (
            offerId &&
            userId &&
            this.zoneRoleInfoCache &&
            this.zoneRoleInfoCache[`${offerId}_${userId}`] &&
            this.zoneRoleInfoCache[`${offerId}_${userId}`].selectedZone
          ) {
            resolve(this.zoneRoleInfoCache[`${offerId}_${userId}`])
          } else {
            let param = {
              // 如果是第三方场景（如快手），不使用缓存queryRole。因为虽然用户选择的大区没有变，但是用户绑定的登录态可能不一样了。使用缓存会导致一直取到旧的绑定登录态
              queryRoleUseCache: this.outerIsThirdSession ? "0" : ""
            }
            if (url.getParam("roleid") && (url.getParam("zoneid") || url.getParam("partition"))) {
              param.cached = {
                zoneid: url.getParam("zoneid"),
                roleid: url.getParam("roleid"),
                partition: url.getParam("partition")
              }
            }
            mobileZoneSelector &&
              mobileZoneSelector
                .parseCachedZoneRole({ ...param })
                .then(res => {
                  if (res && res[0]) {
                    let zoneRoleInfoCache = {
                      selectedZone: res && res[0],
                      selectedRole: res && res[1]
                    }
                    this.setZoneRoleInfoCache({
                      offerId: offerId,
                      userId: userId,
                      zoneRoleInfoCache: zoneRoleInfoCache
                    })
                    if (res[1]?.cgiRes?.bind_ori_user_id)
                      this.setZoneRoleInfoCache({
                        offerId: offerId,
                        userId: res[1].cgiRes.bind_ori_user_id,
                        zoneRoleInfoCache: zoneRoleInfoCache
                      })
                    resolve(zoneRoleInfoCache)
                  } else {
                    this.setParseCachedZoneRolePromise(null)
                    resolve(res)
                  }
                })
                .catch(err => {
                  this.setParseCachedZoneRolePromise(null)
                  reject(err)
                })
          }
        })
        this.setParseCachedZoneRolePromise(parseCachedZoneRolePromise)
      }

      return this.parseCachedZoneRolePromise
    },

    closeMobileZoneSelector() {
      mobileZoneSelector && mobileZoneSelector.close()
    },

    /**
     * 获取大区组件缓存key
     */
    getMobileZoneSelectorCachekey(offerId = "") {
      let clientPf = this.isMobileGame ? (this.userAgent.iOS ? "iap" : "android") : "html5"
      if (clientPf && (this.currentItem?.ams?.offerid || offerId) && this.loginState.openid) {
        return ["game_zone", clientPf, offerId ? offerId : this.currentItem.ams.offerid, this.loginState.openid].join("_")
      } else {
        return ""
      }
    },

    /**
     * 清除大区组件缓存
     */
    clearMobileZoneSelectorCache(offerId = "") {
      if (this.getMobileZoneSelectorCachekey(offerId)) {
        localStorage.del(this.getMobileZoneSelectorCachekey(offerId))
      }
    },

    /**
     * 从store里取用户大区信息
     * @param {} offerId,userId,checkType
     * checkType
     * 1 查点券，使用查角色cgi返回的currency_support_role
     * 2 查道具，使用查角色cgi返回的support_role
     */
    getZoneSelectorCacheZoneInfo({ offerId, userId, checkType = 2, forceSelectedRole = false }) {
      if (this.currentItem.roleType == enums.CHECK_ROLE_TYPE.NO_CHECK && !forceSelectedRole) {
        if (this.isMobileGame) {
          // 如果是手游，且不选大区不选角色，直接读配置台
          return {
            zoneId: this.currentItem[this.userAgent.iOS ? "ios" : "android"][this.provideAccountType.toLowerCase()].zone_id,
            zoneName: ""
          }
        } else if (this.isPcGame) {
          return {
            zoneId: "",
            zoneName: ""
          }
        }
      } else if (this.isPcGame) {
        const zoneRoleInfoCacheKey = `${offerId}_${userId}`
        if (forceSelectedRole && this.zoneRoleInfoCache?.[zoneRoleInfoCacheKey]) {
          let selectedZone = this.zoneRoleInfoCache[zoneRoleInfoCacheKey].selectedZone
          let selectedRole = this.zoneRoleInfoCache[zoneRoleInfoCacheKey].selectedRole

          return this.handleZoneInfo({ selectedZone, selectedRole, checkType, useZoneJs: true, forceSelectedRole })
        } else {
          // 端游还未切大区组件，还是从state.zoneId上取
          return this.userZoneInfo
        }
      } else if (
        offerId &&
        userId &&
        this.zoneRoleInfoCache &&
        this.zoneRoleInfoCache[`${offerId}_${userId}`] &&
        this.zoneRoleInfoCache[`${offerId}_${userId}`].selectedZone
      ) {
        let selectedZone = this.zoneRoleInfoCache[`${offerId}_${userId}`].selectedZone
        let selectedRole = this.zoneRoleInfoCache[`${offerId}_${userId}`].selectedRole

        return this.handleZoneInfo({ selectedZone, selectedRole, checkType })
      } else {
        return {}
      }
    },

    /**
     * 处理大区信息
     * 兼容传值null
     */
    handleZoneInfo(opt = {}) {
      if (opt == null) opt = {}
      let {
        selectedZone,
        selectedRole,
        checkType = 2,
        gameCoinOfferId = "",
        roleType = "",
        useZoneJs = false,
        forceSelectedRole = false
      } = opt
      if (!roleType && this.currentItem?.roleType !== undefined) {
        roleType = this.currentItem?.roleType
      }

      if (!useZoneJs && ((this.currentItem?.zone_js && this.currentItem?.zone_key) || this.forceUseZoneJs)) {
        useZoneJs = true
      }
      let userZoneInfo = {}
      if (selectedRole?.ban_status == 1) {
        this.setToastMsg("当前账号已被封禁，暂无法充值")
        return userZoneInfo
      }
      if (selectedZone && selectedRole) {
        let cgiRes = (selectedRole && selectedRole.cgiRes) || {}
        let partition_info = (selectedRole && selectedRole.partition_info) || {}

        // 注意！！这里有个特殊逻辑
        // 当接入商店的游戏需要用大区js时，必须保证zoneid和partition一一对应，否则不可使用大区js或上商店
        let zoneJsZoneId
        if (useZoneJs && !selectedZone.zone_id) {
          // lol手游只有一个默认分区，partition为空，所以要将partition置为默认1
          zoneJsZoneId = selectedZone.partition || 1
        }

        // 出生服
        let originZoneId = selectedRole.midas_zone_id || selectedZone.zone_id || zoneJsZoneId

        // gameCoinShowZoneRoleName 点券货架里展示大区角色 （需要选角色的游戏示例：大区名/角色名 || 无需选角色的游戏示例：大区名）
        // propsShowZoneRoleName 道具页展示大区角色 （有角色名的游戏示例：大区名 角色名 || 无角色名的游戏示例：大区名）
        if (
          (checkType === 2 && selectedRole.support_role == "1") ||
          (checkType === 1 && selectedRole.currency_support_role == "1") ||
          (forceSelectedRole && useZoneJs)
        ) {
          userZoneInfo.zoneId = `${originZoneId}_${selectedRole.role_id}`
          userZoneInfo.gameCoinShowZoneRoleName = `${selectedZone.zone_name}/${selectedRole.role_name}`
          userZoneInfo.gameid = `${partition_info.area}_${selectedRole.role_id}__${partition_info.partition}`
        } else {
          userZoneInfo.zoneId = originZoneId
          userZoneInfo.gameCoinShowZoneRoleName = selectedZone.zone_name
          userZoneInfo.gameid = `${partition_info.area}___${partition_info.partition}`
        }

        userZoneInfo.area = partition_info.area
        userZoneInfo.partition = partition_info.partition
        userZoneInfo.zoneName = selectedZone.zone_name
        userZoneInfo.roleName = selectedRole.role_name
        userZoneInfo.roleId = selectedRole.role_id
        userZoneInfo.propsShowZoneRoleName = userZoneInfo.zoneName + " " + (userZoneInfo.roleName ? userZoneInfo.roleName : "")
        if (this.isPcGame && !partition_info.platid) {
          userZoneInfo.gamePlatformId = this.userAgent.android ? "android" : "iap"
        } else {
          userZoneInfo.gamePlatformId = partition_info.platid
        }
        // 第三方登录态（快手）时，查角色时会返回对应绑定的账号id和type（uin或wechatid）   ----- todo 半年内没有使用可以删除
        userZoneInfo.bind_user_id = cgiRes && cgiRes.bind_user_id
        userZoneInfo.bind_user_type = cgiRes && cgiRes.bind_user_type

        // 第三方登录态 绑定的微信orQQ登录态
        userZoneInfo.bind_ori_user_id = cgiRes?.bind_ori_user_id || ""
        userZoneInfo.bind_user_access_token = cgiRes?.bind_user_access_token || ""
        userZoneInfo.bind_user_appid = cgiRes?.bind_user_appid || ""

        // 特殊情况：互通服等
        userZoneInfo.goods_zoneid = `${partition_info.partition}${selectedRole.role_id ? `_${selectedRole.role_id}` : ""}`
        userZoneInfo.isInterworkingZone = selectedZone.is_interworking == "1" ? 1 : ""
        userZoneInfo.zoneOfferId = selectedZone.is_interworking == "1" ? selectedZone.interworking_offerid : gameCoinOfferId
      } else if (roleType && roleType == enums.CHECK_ROLE_TYPE.NO_CHECK) {
        if (this.isMobileGame) {
          // 如果是手游，且不选大区不选角色，直接读配置台
          userZoneInfo = {
            zoneId: this.currentItem[this.userAgent.iOS ? "ios" : "android"][this.provideAccountType.toLowerCase()].zone_id,
            zoneName: "",
            zoneOfferId: gameCoinOfferId
          }
        } else if (this.isPcGame) {
          userZoneInfo = {
            zoneId: "",
            zoneName: ""
          }
        }
      } else {
        userZoneInfo = {
          zoneId: "",
          zoneName: "",
          roleName: "",
          gameid: "",
          gamePlatformId: ""
        }
      }
      return userZoneInfo
    },

    // 设置展示层级的大区数据
    setZoneSelectorZoneInfo(userZoneInfo = {}) {
      this.userZoneInfo = {
        ...this.userZoneInfo,
        ...userZoneInfo
      }
    },

    clearZoneSelectorZoneInfo() {
      this.userZoneInfo = {}
    },

    /**
     * 获取承载号id
     */
    getAccountId() {
      let accountId = ""
      if (this.provideAccountType == enums.ACCOUNT_TYPE.QQ) {
        //QQ互联登录态可能没有provideUin,因此没有的时候需要用openid做主键
        accountId = this.provideUin || this.loginState.openid
      } else if (this.provideAccountType == enums.ACCOUNT_TYPE.WX) {
        accountId = this.loginState.openid
      }
      return accountId
    },

    // 小程序内和浏览器内 切换账号
    changeLoginAccount() {
      if (this.userAgent.inThirdApp) {
        // 快手内切换账号为绑定
        this.$SelectAccountPrompt({
          selectAccount: this.selectAccount
        }).show()
      } else if ((this.userAgent.weixinminiprogram || this.fromMini) && this.userAgent.weixin) {
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({
          url: "/webviewPage/pages/qqlogin/qqlogin?isSwitch=1&url=" + encodeURIComponent(url.delParam(["code"], location.href))
        })
      } else {
        this.showAppLogin()
      }
    },

    // 清楚用户所有的大区角色缓存（localstorage的，store的）
    clearUserZoneRoleCache({ offerId }) {
      try {
        // 清空缓存
        this.clearMobileZoneSelectorCache(offerId)
        // 清空store里的大区角色cache。【新增】因为之前换绑后页面会刷新，现在不刷新，需要手动重置
        this.setParseCachedZoneRolePromise(null)
        let accountId = this.getAccountId()
        this.setZoneRoleInfoCache({
          offerId,
          userId: accountId,
          zoneRoleInfoCache: {}
        })
        // 清除store的userZoneInfo（存储了绑定信息，大区角色信息）
        this.clearZoneSelectorZoneInfo()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
